import { render } from "./commuinty-home.vue?vue&type=template&id=168fc632&scoped=true&ts=true"
import script from "./commuinty-home.vue?vue&type=script&lang=ts"
export * from "./commuinty-home.vue?vue&type=script&lang=ts"

import "./commuinty-home.vue?vue&type=style&index=0&id=168fc632&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168fc632"]])

export default __exports__